// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsProductCarousel__productCard{width:230px;min-height:200px}@media(min-width: 1024px){.NsProductCarousel__productCard{width:315px}}", ""]);
// Exports
exports.locals = {
	"productCard": "NsProductCarousel__productCard"
};
module.exports = exports;
